module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABBklEQVRIS7XVSQrCQBAF0KrWU3ggwTs4kygYBxwW4tKNGzfGhcSIJp5C8Dxewy8KCg7pEXub5r9qulLN9OfFf84nKbCOkiEYE0Ac+63qjJlhWpAUCLeHC0CFeygz7Xt+3TNFpMAqShdE1+mzahtECgDgdZzsAGraIspLdkWUwL1yF0QLcEG0AVvECLBBjIEshHJUGniN0+ePaAuIcJumRCg/A3MiX+z6lbMzAOArnIk3/Xa982uMGJ0gK7zXqgVZI0QbsAl/zDCd6WgbrgW4hCsB13AlEEbJEoTxa5ISb2QXatxFbw+ORbjyBKs4CeiKkRDi2PWqc9PXTAnodJhqj1abqkJk3292kMEZvqkxpAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product-detail/icon-right.png
// module id = 1guF
// module chunks = 4